import { createClient } from '@supabase/supabase-js'

const { APP_SUPABASE_PROJECT, APP_SUPABASE_KEY } = import.meta.env

export const supabase = createClient(APP_SUPABASE_PROJECT, APP_SUPABASE_KEY)